import { useMemo } from 'react'
import { useIntl } from 'intl'
import { useInquire } from 'modules/payment'
import { buttonMessages } from 'components/inputs'


const usePayButtonInfoFromInquire = () => {
  // inquire context can be null, if we are in card update flow
  const inquireContext = useInquire()
  const intl = useIntl()

  const defaultTitle = useMemo(() => {
    if (inquireContext) {
      return {
        ...buttonMessages.payWithTotal,
        values: {
          total: inquireContext.orderData?.total ? intl.formatPrice(inquireContext.orderData.total) : '',
        },
      }
    }

    return buttonMessages.pay
  }, [ intl, inquireContext ])

  return {
    defaultTitle,
    isInquireFetching: inquireContext?.isFetching,
  }
}


export default usePayButtonInfoFromInquire
